import { Inject, Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import {
  PaginatorResponse,
  PostUser,
  UserResponse,
} from '../../../models/login.models';
import { GetUsuariosRequest } from '../../../models/usuarios.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class NewApiUsuariosService extends UtilsBaseApiService<NewApiUsuariosService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('usuario', injector, environment.BASE_API_URL);
  }

  getUsuarios(
    request: GetUsuariosRequest
  ): Observable<PaginatorResponse<UserResponse>> {
    return this.httpClient.get<PaginatorResponse<UserResponse>>(
      `${this.BASE_URL}${this.CONTEXT}/${request.index}/${request.length}`
    );
  }

  createUsuario = (usuario: PostUser) =>
    this.create<PostUser, UserResponse>(usuario);

  deleteUsuario = (id: number) => this.delete<UserResponse>(id);

  putUsuario = (usuario: PostUser) => this.update<PostUser>(usuario);
}
